import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfigService } from '../auth/services/app-config.service';

export interface UserToken{
    sub: string;
    mail: string;
    roles: Array<string>;
}

export interface ValidationResult{
    validationStatus: string;
    user: UserToken;
}  

@Injectable({providedIn: 'root'})
export class HomeService {

    constructor(private http: HttpClient, private appConfig: AppConfigService) {

    }

    validateUserPermission(){
        return this.http.get<ValidationResult>(`${this.appConfig.config.baseUrlLogin}${this.appConfig.config.backendUrl}`+'/validate-user', {responseType : 'json'});
    }
}